<script>

import Icon from '../../components/Icon.vue';
import ClickOutside from 'vue-click-outside';

export default {
  components: {Icon},
  props: {
    value: {
      type: [Array, Object],
      required: false,
      default: () =>
        new Object({ newValue: null, previous: null, action: 'none'}),
    },
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    forceHide(e) {
      if (e.target.classList.contains('comment-input') && e.target.id === this.name) {
        this.displayComment(e);
      } else if (this.show) {
        this.show = false;
      }
    },

    displayComment(e) {
      if (e.x < (2 * window.outerWidth / 3)) {
        document.querySelectorAll(`.comment-text[name='${this.name}']`)[0].classList.remove('right-0');
      }
      this.show = !this.show;
    }
  },

  computed: {
    valueAsStr() {
      let result = '';

      this.valueComp.forEach(({ newValue, action, previous }, idx) => {
        if (action === 'added') {
          result += `+ ${newValue}`;
        } else if (action === 'deleted') {
          result += `- ${previous}`;
        } else if (action === 'updated') {
          result += `${previous} -> ${newValue}`;
        } else {
          result += newValue ?? '';
        }
        if (idx + 2 <= this.value.length) {
          result += ', ';
        }
      });

      return result;
    },

    valueComp() {
      if (Array.isArray(this.value.value ?? null)) {
        return this.value.value;
      }

      return [this.value];
    }
  },

  directives: {
    ClickOutside
  }
};

</script>

<template>
  <div class="text-gray-600 w-full md:w-auto">
    <div class="cursor-pointer inline-block w-max">
      <icon
        :id="name"
        name="message-circle"
        class="comment-input"
      />
    </div>
    <div class="relative">
      <textarea
        class="comment-text absolute z-20 top-0 right-0 w-full md:w-auto bg-white py-4 px-5 rounded-lg shadow-md shadow-gray-600 text-base focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50"
        :class="{
          'text-teal-600': value.action === 'added',
          'text-indigo-600': value.action === 'updated',
          'text-pink-600': value.action === 'deleted',
          'text-gray-600': value.action === 'none',
        }"
        rows="9"
        cols="40"
        v-show="show"
        v-click-outside="forceHide"
        :value="valueAsStr"
      />
    </div>
  </div>
</template>